/* ============================================================
   BDP — botão de compartilhar da galeria da PDP
   Web Share API quando existe (mobile abre o sheet nativo);
   fallback: copia o link e mostra "Link copiado!" por 1.6s.
   ============================================================ */
if (!customElements.get('bdp-share-button')) {
  customElements.define(
    'bdp-share-button',
    class BdpShareButton extends HTMLElement {
      connectedCallback() {
        var btn = this.querySelector('.bdp-share__btn');
        var tip = this.querySelector('.bdp-share__tip');
        if (!btn) return;
        var url = this.dataset.shareUrl || window.location.href;
        var title = this.dataset.shareTitle || document.title;

        btn.addEventListener('click', function () {
          if (navigator.share) {
            navigator.share({ title: title, url: url }).catch(function () {});
            return;
          }
          var show = function () {
            if (!tip) return;
            tip.hidden = false;
            window.clearTimeout(tip.bdpTimer);
            tip.bdpTimer = window.setTimeout(function () {
              tip.hidden = true;
            }, 1600);
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(show, show);
          } else {
            show();
          }
        });
      }
    }
  );
}
